import React, { useState } from "react";
import { testimonials } from "../mock";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];
  const prev = () => setIdx((idx - 1 + testimonials.length) % testimonials.length);
  const next = () => setIdx((idx + 1) % testimonials.length);

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <div className="section-label mb-4">Testimonials</div>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-gray-900 spaced-heading leading-tight">
            What Our <span className="text-brand">Clients Say</span>
          </h2>
          <div className="mt-8 flex items-baseline gap-3">
            <div className="font-display text-6xl font-bold text-brand">95<span className="text-3xl">%</span></div>
            <div className="text-gray-700">
              <div className="font-bold">Client Satisfaction</div>
              <div className="text-sm text-gray-500">Across recruitment, training & BPO engagements</div>
            </div>
          </div>
          <div className="mt-8 flex gap-3">
            <button onClick={prev} aria-label="prev" className="w-12 h-12 rounded-full border-2 border-brand text-brand hover:bg-brand hover:text-white flex items-center justify-center">
              <ChevronLeft size={20} />
            </button>
            <button onClick={next} aria-label="next" className="w-12 h-12 rounded-full bg-brand text-white hover:bg-brand-dark flex items-center justify-center">
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        <div className="relative">
          <div className="bg-gray-50 border border-gray-100 rounded-3xl p-10 relative">
            <Quote className="absolute top-6 right-6 text-brand/20" size={72} />
            <div className="flex gap-1 mb-4">
              {Array.from({ length: t.rating }).map((_, i) => (
                <Star key={`${t.id}-star-${i}`} size={18} className="text-brand" fill="currentColor" />
              ))}
            </div>
            <p className="text-lg text-gray-800 leading-relaxed">“{t.text}”</p>
            <div className="mt-6 flex items-center gap-4 pt-6 border-t border-gray-200">
              <img src={t.avatar} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-brand" />
              <div>
                <div className="font-bold text-gray-900">{t.name}</div>
                <div className="text-sm text-brand">{t.role}</div>
              </div>
            </div>
          </div>
          <div className="mt-4 flex gap-2 justify-center">
            {testimonials.map((tItem, i) => (
              <button key={tItem.id} onClick={() => setIdx(i)} aria-label={`slide-${i}`} className={`h-1.5 rounded-full transition-all ${i === idx ? "w-8 bg-brand" : "w-2 bg-gray-300"}`} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
